jQuery( window ).on( 'elementor/frontend/init', () => {
	window.elementorFrontend.hooks.addAction( 'frontend/element_ready/ele_joy_posts_tab.default', function() {
		$('.joy-posts-tab a.jb-tab-title').click(function (){
			$('.joy-posts-tab a.jb-tab-title').removeClass('jb-tab-title__active');
			$(this).addClass('jb-tab-title__active');

			$('.jb-tab-wrap-content .jb-tab-content', $(this).parent().parent()).removeClass('jb-tab-content__active');
			console.log($(this).attr('href'));
			$($(this).attr('href')).addClass('jb-tab-content__active');
			return false;
		});
	} );
} );